import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ToggleButtonGroup from '@wix/da-shared-react/pkg/ToggleButtonGroup';
import GalleryTorpedoIcon from '@wix/da-ds/pkg/Icons/24x24/GalleryTorpedo';
import StackedIcon from '@wix/da-ds/pkg/Icons/24x24/Stacked';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';

export interface Props {
  isStacked?: boolean;
}

const ViewSwitcher: React.FC<Props> = ({ isStacked }) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);

  if (isMobile) {
    if (isStacked) {
      return (
        <IconButton
          size="medium"
          icon={GalleryTorpedoIcon}
          href="?stacked=0"
          aria-label={t('view.grid.button.a11y.label')}
          biData={{
            evid: BiEventType.WATCH_GROUP_BY_ARTIST_CLICK,
            is_grouped: isStacked ? 1 : 0,
          }}
        />
      );
    }

    return (
      <IconButton
        size="medium"
        icon={StackedIcon}
        href="?stacked=1"
        aria-label={t('view.stack.button.a11y.label')}
        biData={{
          evid: BiEventType.WATCH_GROUP_BY_ARTIST_CLICK,
          is_grouped: isStacked ? 1 : 0,
        }}
      />
    );
  }

  return (
    <ToggleButtonGroup
      value={isStacked ? 'stack' : 'grid'}
      onChange={value => {
        if (value === 'stack') {
          window.location.assign('?stacked=1');
        }
        if (value === 'grid') {
          window.location.assign('?stacked=0');
        }
      }}
      buttons={[
        {
          tooltipText: t('view.grid.button.tooltip'),
          ariaLabel: t('view.grid.button.a11y.label'),
          icon: GalleryTorpedoIcon,
          value: 'grid',
          biData: {
            evid: BiEventType.WATCH_GROUP_BY_ARTIST_CLICK,
            is_grouped: isStacked ? 1 : 0,
          },
        },
        {
          tooltipText: t('view.stack.button.tooltip'),
          ariaLabel: t('view.stack.button.a11y.label'),
          icon: StackedIcon,
          value: 'stack',
          biData: {
            evid: BiEventType.WATCH_GROUP_BY_ARTIST_CLICK,
            is_grouped: isStacked ? 1 : 0,
          },
        },
      ]}
    />
  );
};
ViewSwitcher.displayName = 'ViewSwitcher';

export default ViewSwitcher;
